"use client";
import { ProductBadge } from "@/app/lib/features/product/product.types";
import Image from "next/image";
import RotatingText from "@/app/components/common/sections/RotationText";

interface ProductCardBadgesProps {
  badges: ProductBadge[];
}

const ProductCardBadges = ({ badges }: ProductCardBadgesProps) => {
  if (!badges || badges.length === 0) return null;

  const rotatingItems = badges
    .filter((badge) => badge && badge.label) // Filter out invalid badges
    .map((badge) => ({
      text: badge.label,
      icon: badge.icon_full ? (
        <Image
          src={badge.icon_full}
          alt={badge.label}
          width={12}
          height={12}
          className="shrink-0"
        />
      ) : undefined,
      style: badge.color_hex
        ? {
            backgroundColor: badge.color_hex,
            color: "white",
          }
        : {
            backgroundColor: "#4B5563", // gray-600 fallback
            color: "white",
          },
    }));

  if (rotatingItems.length === 0) return null;

  return (
    <RotatingText
      items={rotatingItems}
      className="text-[10px] sm:text-xs text-white font-medium py-0.5 px-2 w-full justify-center"
      mainClassName="w-full"
      rotationInterval={3000}
      loop={true}
      auto={true}
    />
  );
};

export default ProductCardBadges;
